import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';
import AttemptQuestion from './routes/AttemptQuestion';

const LazyStudentExamAttempt = React.lazy(
	() => import(/* webpackChunkName: 'StudentExamAttempt' */ './components')
);

export default () => {
	return {
		path: 'exam/:examConfigId/:examAttemptId',
		element: <AsyncLoading component={<LazyStudentExamAttempt />} />,
		children: [AttemptQuestion()],
	};
};
